import { createAction } from '@reduxjs/toolkit';

// Semantic lifecycle events bridged from VoiceMeetingListener (RxJS) into Redux.
// callCaptionsSlice extraReducers and callCaptionsListenerMiddleware subscribe to these.
export const voiceSessionFinished = createAction('voiceSession/finished');
export const voiceSessionReset = createAction('voiceSession/reset');
export const voiceSessionTeamingLeaveReset = createAction(
  'voiceSession/teamingLeaveReset'
);
